import React, { ReactNode, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RotatingLines } from "react-loader-spinner";
import { communitySubscriptions } from "../../../redux/community-subscriptions/action";
import { communities } from "../../../redux/community/action";
import { useAppDispatch } from "../../../hooks/hooks";
import storePersist from "../../../redux/storePersist";
import * as R from 'ramda';
import { selectCommunitiesCreatedItem, selectCommunitiesListItems } from "../../../redux/community/selector";
import { useNavigate } from "react-router-dom";

export const CommunitySubscription: React.FC = () => {
  const dispatch = useAppDispatch();
  const [topics, setTopics] = useState<any>([]);
  const [isButtonLoading, setIsButtonLoading] = useState<boolean>(false);
  const statesItem = storePersist?.get("states")?.current?.items || [];
  const countriesItem = storePersist?.get("countries")?.current?.items || [];
  const communitiesList = useSelector(selectCommunitiesListItems);
  const listcommunities = useSelector(selectCommunitiesCreatedItem);
  const navigate = useNavigate();

  const [selectedCommunities, setSelectedCommunities] = useState<any>({
    Login: { Phone: "", Email: "" },
    UserProfile: { FirstName: "", LastName: "", PersonTitle: "" },
    ONEUserInfo: {
      Biography: null,
      PhotoUrl: null,
      IsONEUserVerified: true,
      StartupName: "",
      YearsInOperation: "",
      IsTechFirstInnovation: true,
      StageOfTheStartup: "",
      Sector: "",
      WebsiteLink: "",
      utm_source: null,
      utm_medium: null,
      utm_campaign: null,
      utm_term: null,
      utm_content: null,
    },
    Account: { IsPersonAccount: true, Name: "", TypeId: "" },
    PrimaryAddress: {
      address1: "",
      address2: "",
      city: "",
      CountryId: "",
      StateProvinceId: "",
      ZipPostalCode: "",
    },
  });

  const resetForm = () => {
    setSelectedCommunities({
      Login: { Phone: "", Email: "" },
      UserProfile: { FirstName: "", LastName: "", PersonTitle: "" },
      ONEUserInfo: {
        Biography: null,
        PhotoUrl: null,
        IsONEUserVerified: true,
        StartupName: "",
        YearsInOperation: "",
        IsTechFirstInnovation: true,
        StageOfTheStartup: "",
        Sector: "",
        WebsiteLink: "",
        utm_source: null,
        utm_medium: null,
        utm_campaign: null,
        utm_term: null,
        utm_content: null,
      },
      Account: { IsPersonAccount: true, Name: "", TypeId: "" },
      PrimaryAddress: {
        address1: "",
        address2: "",
        city: "",
        CountryId: "",
        StateProvinceId: "",
        ZipPostalCode: "",
      },
    });
  };

  useEffect(() => {
    if (listcommunities?.isSuccess) {
      dispatch(communitySubscriptions.resetAction({ actionType: "create" }));
      dispatch(
        communitySubscriptions.create({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/subscriptions`,
          entity: "programs",
          jsonData: {
            Context: {},
            Records: [
              {
                Email: selectedCommunities?.Login?.Email,
                PhoneNumber: selectedCommunities?.Login?.Phone,
                OwnerType: "onecommunities",
                CommunityId: selectedCommunities?.CommunityId,
                IsExistingUser: selectedCommunities?.IsExistingUser || false,
              },
            ],
          },
        })
      );
      resetForm();
      dispatch(communities.resetAction({ actionType: "create" }));
    }
  }, [listcommunities]);

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    const data = {
      Login: { Phone: selectedCommunities?.Login?.Phone, Email: selectedCommunities?.Login?.Email },
      UserProfile: { FirstName: selectedCommunities?.UserProfile?.FirstName, LastName: "", PersonTitle: "" },
      ONEUserInfo: {
        Biography: null,
        PhotoUrl: null,
        IsONEUserVerified: true,
        StartupName: selectedCommunities?.ONEUserInfo?.StartupName,
        YearsInOperation: "",
        IsTechFirstInnovation: true,
        StageOfTheStartup: selectedCommunities?.ONEUserInfo?.StageOfTheStartup,
        Sector: selectedCommunities?.ONEUserInfo?.Sector,
        WebsiteLink: selectedCommunities?.PrimaryAddress?.WebsiteLink,
        utm_source: null,
        utm_medium: null,
        utm_campaign: null,
        utm_term: null,
        utm_content: null,
      },
      Account: { IsPersonAccount: true, Name: "ONE User 001", TypeId: 440 },
      PrimaryAddress: {
        address1: selectedCommunities?.PrimaryAddress?.address1,
        address2: selectedCommunities?.PrimaryAddress?.address2,
        city: selectedCommunities?.PrimaryAddress?.city,
        CountryId: selectedCommunities?.PrimaryAddress?.CountryId,
        StateProvinceId: selectedCommunities?.PrimaryAddress?.StateProvinceId,
        ZipPostalCode: selectedCommunities?.PrimaryAddress?.ZipPostalCode,
      },
    };

    if (!selectedCommunities?.IsExistingUser) {
      await dispatch(communities.resetAction({ actionType: "create" }));
      await dispatch(
        communities.create({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/one-users`,
          entity: "register",
          jsonData: { records: [data] },
        })
      );
      resetForm();
    } else {
      dispatch(
        communitySubscriptions.create({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/subscriptions`,
          entity: "programs",
          jsonData: {
            Context: {},
            Records: [
              {
                Email: selectedCommunities?.Email,
                PhoneNumber: selectedCommunities?.Phone,
                OwnerType: "onecommunities",
                CommunityId: selectedCommunities?.CommunityId,
                IsExistingUser: selectedCommunities?.IsExistingUser || false,
              },
            ],
          },
        })
      );
      resetForm();
    }
  };

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedCommunities({ ...selectedCommunities, [fields[0]]: value });
  }

  const handleChange: any = (event: any, field: string) => {
    setSelectedCommunities({ ...selectedCommunities, [field]: event })

  }


  useEffect(() => {
    dispatch(
      communities.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/community/communities/list`,
        entity: "community",
        jsonData: { Context: { Subscription: "ONE", Domain: "ONE", SubDomains: [], Network: "Internal", Application: "Management", Channel: "Portal" }, Records: [{ Id: 0 }] },
      })
    );
  }, []);

  useEffect(() => {
    if (communitiesList) setTopics(communitiesList.result?.items || []);
  }, [communitiesList]);



  const H2: React.FC<{ children: ReactNode; kicker?: string; center?: boolean }> = ({ children, kicker, center }) => (
    <div className={`mb-8 ${center ? "text-center" : ""}`}>
      {kicker && <div className="mb-2 text-sm font-semibold tracking-widest uppercase text-indigo-600">{kicker}</div>}
      <h2 className="text-3xl md:text-4xl font-extrabold text-slate-800">{children}</h2>
    </div>
  );


  return (
    <div id="join" className="bg-gradient-to-b from-slate-50 to-white border-t border-slate-200 px-6">
      <div className="py-16">
        <H2 kicker="Join" center>Become a member or a Chapter Lead</H2>

        <div className="grid lg:grid-cols-3 gap-8">
          <div className="p-6 bg-white rounded-xl border border-slate-200 shadow-sm lg:col-span-2">
            <form className="grid grid-cols-1 sm:grid-cols-2 gap-6">

              <div className="sm:col-span-2 flex items-center">
                <input
                  type="checkbox"
                  id="IsExistingUser"
                  checked={selectedCommunities?.IsExistingUser || false}
                  onChange={(e) => handleChange(e.target.checked, "IsExistingUser")}
                  className="mr-2 w-4 h-4"
                />
                <label htmlFor="IsExistingUser" className="text-sm text-slate-600">Are you already registered?</label>
              </div>


              {!selectedCommunities?.IsExistingUser && (
                <>
                  <div>
                    <label className="text-sm text-slate-600">Full Name</label>
                    <input
                      type="text"
                      value={selectedCommunities?.UserProfile?.FirstName || ""}
                      onChange={(event) => {
                        handleInnerFormChange(
                          event.target.value,
                          'UserProfile.FirstName',
                          selectedCommunities?.UserProfile
                        );
                      }}
                      placeholder="Your name"
                      required
                      className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                  </div>

                  <div>
                    <label className="text-sm text-slate-600">Email</label>
                    <input
                      type="email"
                      value={selectedCommunities?.Login?.Email || ""}
                      onChange={(event) => {
                        handleInnerFormChange(
                          event.target.value,
                          'Login.Email',
                          selectedCommunities?.Login
                        );
                      }}
                      placeholder="you@email.com"
                      required
                      className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                  </div>

                  <div>
                    <label className="text-sm text-slate-600">Phone</label>
                    <input
                      type="text"
                      maxLength={10}
                      value={selectedCommunities?.Login?.Phone || ""}
                      onChange={(event) => {
                        handleInnerFormChange(
                          event.target.value.replace(/\D/g, ''),
                          'Login.Phone',
                          selectedCommunities?.Login
                        );
                      }}
                      placeholder="10-digit number"
                      required
                      className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                    {selectedCommunities?.Login?.Phone && selectedCommunities?.Login?.Phone.length < 10 && (
                      <span className="text-red-600 text-xs">Please enter a valid number.</span>
                    )}
                  </div>

                  <div>
                    <label className="text-sm text-slate-600">Building</label>
                    <input
                      type="text"
                      value={selectedCommunities?.PrimaryAddress?.address1 || ""}
                      onChange={(event) => {
                        handleInnerFormChange(
                          event.target.value,
                          'PrimaryAddress.address1',
                          selectedCommunities?.PrimaryAddress
                        );
                      }}
                      placeholder="Building"
                      required
                      className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                  </div>

                  <div>
                    <label className="text-sm text-slate-600">Locality</label>
                    <input
                      type="text"
                      value={selectedCommunities?.PrimaryAddress?.address2 || ""}
                      onChange={(event) => {
                        handleInnerFormChange(
                          event.target.value,
                          'PrimaryAddress.address2',
                          selectedCommunities?.PrimaryAddress
                        );
                      }}
                      placeholder="Locality"
                      required
                      className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                  </div>

                  <div>
                    <label className="text-sm text-slate-600">City</label>
                    <input
                      type="text"
                      value={selectedCommunities?.PrimaryAddress?.city || ""}
                      onChange={(event) => {
                        handleInnerFormChange(
                          event.target.value,
                          'PrimaryAddress.city',
                          selectedCommunities?.PrimaryAddress
                        );
                      }}
                      placeholder="City"
                      required
                      className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                  </div>

                  <div>
                    <label className="text-sm text-slate-600">Pincode</label>
                    <input
                      type="text"
                      value={selectedCommunities?.PrimaryAddress?.ZipPostalCode || ""}
                      onChange={(event) => {
                        handleInnerFormChange(
                          event.target.value,
                          'PrimaryAddress.ZipPostalCode',
                          selectedCommunities?.PrimaryAddress
                        );
                      }}
                      placeholder="Pincode"
                      required
                      className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                  </div>

                  <div>
                    <label className="text-sm text-slate-600">Country</label>
                    <select
                      value={selectedCommunities?.PrimaryAddress?.CountryId || ""}
                      onChange={(event) => handleInnerFormChange(event.target.value, 'PrimaryAddress.CountryId',
                        selectedCommunities?.PrimaryAddress
                      )}
                      required
                      className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    >
                      <option value="" disabled>Select Country</option>
                      {countriesItem.map((c: any) => (
                        <option key={c.Id} value={c.Id}>{c.Name}</option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="text-sm text-slate-600">State</label>
                    <select
                      value={selectedCommunities?.PrimaryAddress?.StateProvinceId || ""}
                      onChange={(event) => handleInnerFormChange(event.target.value, 'PrimaryAddress.StateProvinceId',
                        selectedCommunities?.PrimaryAddress
                      )}
                      required
                      className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    >
                      <option value="" disabled>Select State</option>
                      {statesItem.length > 0 ? (
                        statesItem.map((s: any) => <option key={s.Id} value={s.Id}>{s.Name}</option>)
                      ) : (
                        <option disabled>No states available</option>
                      )}
                    </select>
                  </div>
                </>
              )}

              {/* Existing User Form */}
                {selectedCommunities?.IsExistingUser && (
                <div className="sm:col-span-2 space-y-4">
                  {!selectedCommunities?.Email && !selectedCommunities?.Phone && (
                    <label className="text-sm text-slate-600">
                      Please enter <span className="text-blue-600 font-semibold">either your Email or Phone Number</span>
                    </label>
                  )}

                  <div className="flex space-x-4">
                    {!selectedCommunities?.Phone && (
                      <div className="flex-1">
                        <label className="text-sm text-slate-600">Email</label>
                        <input
                          type="email"
                          required
                          value={selectedCommunities?.Email || ""}
                          onChange={(e) => handleChange(e.target.value, "Email")}
                          placeholder="you@email.com"
                          className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                      </div>
                    )}

                    {!selectedCommunities?.Email && (
                      <div className="flex-1">
                        <label className="text-sm text-slate-600">Phone</label>
                        <input
                          type="text"
                          maxLength={10}
                          required
                          value={selectedCommunities?.Phone || ""}
                          onChange={(e) => handleChange(e.target.value.replace(/\D/g, ""), "Phone")}
                          placeholder="10-digit number"
                          className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                        {selectedCommunities?.Phone?.length > 0 && selectedCommunities?.Phone?.length < 10 && (
                          <span className="text-red-600 text-xs">Please enter a valid number.</span>
                        )}
                      </div>
                    )}
                  </div>

                </div>
              )}

              {/* Community Selection */}
              <div className="sm:col-span-2">
                <label className="text-sm text-slate-600">Select a Community</label>
                <select
                  value={selectedCommunities?.CommunityId || ""}
                  onChange={(event) => handleChange(event.target.value, 'CommunityId')}
                  required
                  className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                >
                  <option value="" disabled>Pick a community…</option>
                  {topics.map((c: any) => (
                    <option key={c.Id} value={c.Id}>{c.Name}</option>
                  ))}
                </select>
              </div>

              <div className="sm:col-span-2 flex justify-center space-x-4">
                {/* Subscribe Button */}
                <button
                  type="submit"
                  onClick={handleSubmit}
                  className="inline-flex items-center justify-center px-6 py-3 rounded-xl 
               bg-indigo-600 text-white font-semibold shadow hover:bg-indigo-700 
               focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  {isButtonLoading ? (
                    <RotatingLines
                      strokeColor="white"
                      strokeWidth="5"
                      animationDuration="0.75"
                      width="24"
                      visible={true}
                    />
                  ) : (
                    "Subscribe"
                  )}
                </button>

                {/* Back Button */}
                <button
                  type="button"
                  onClick={() => navigate("/communities")}
                  className="inline-flex items-center justify-center px-6 py-3 rounded-xl 
               bg-gray-500 text-white font-semibold shadow hover:bg-gray-600 
               focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400"
                >
                  Back
                </button>
              </div>



            </form>
          </div>


          <div className="space-y-4">
            <div className="p-6 bg-white rounded-xl border border-slate-200 shadow-sm">
              <div className="font-semibold text-slate-900">How membership works</div>
              <ul className="mt-2 text-sm text-slate-600 list-disc pl-5 space-y-1">
                <li>Free to join. Upgrade to workshops via Academy when needed.</li>
                <li>Access playbooks, tools, and partner programs.</li>
                <li>Attend city meetups and online clinics.</li>
              </ul>
            </div>
            <div className="p-6 bg-white rounded-xl border border-slate-200 shadow-sm">
              <div className="font-semibold text-slate-900">Partner with us</div>
              <div className="mt-2 text-sm text-slate-600">Banks, logistics, SaaS, and corporates can run clinics, offer credits, and sponsor cohorts.</div>
              <a href="#" className="mt-3 inline-flex items-center justify-center rounded-full px-4 py-2 border border-slate-300 hover:bg-slate-50 text-sm font-semibold">View Partner Guide</a>
            </div>

          </div>



        </div>
      </div>
    </div>
  );
};
